import React from 'react';
import { useLocation, useHistory } from 'react-router-dom'
import { Box, Tabs, Tab, Typography, Card, CardContent, Button, CardHeader, Divider } from '@mui/material'
import { ContactTab } from './ContactTab'
import { copyObject } from '../../components/TimerView';
import { useImmer } from 'use-immer';
import AddressTab from './AddressTab';

import AgreeTab from './AgreeTab';
import _ from 'lodash';
import { getQueryStringParams } from '../../utils/utilsT';
import RegisterJobInfoTab from './RegisterJobInfoTab';
import { JobT } from '../../types/Job';
import { JobObj } from '../jobs/NewJob/InitObjectJob';
import RegisterLocationsTab from './RegisterLocationsTab';
import ApartmentIcon from '@mui/icons-material/Apartment';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CompanyTab from './CompanyTab';
import WorkerTab from './WorkerTab';
export interface UserRegisterT {
    address: string
    address2: string
    agree: boolean
    email: string
    firstName: string
    lastName: string
    phone: string
    password: string
    confirmPassword: string
    accountType?: "company" | "worker"
    companyName?: string
    companyLogo?: string
    companyAddress?: string
    equipment?: Array<string>
    // equipment?:"Dolly"|"Floor Dolly"|"Ratchet Straps"|"Moving Pads (at least 5)"
}


export const InitUserRegisterObj: UserRegisterT = {
    address: '',
    address2: '',
    agree: null,
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    password: "",
    confirmPassword: "",
    accountType: null,
    companyName: null,
    companyLogo: null,
    companyAddress: null,
    equipment: [],
}
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}


function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
export type IRegisterScreenProps = {

}

interface TabItem {
    key: string
    title: string
    icon: string
}

const routesTabs = [
    { key: 'contact', title: 'Contact', icon: "ios-person-outline" },
    { key: 'address', title: 'Address', icon: "ios-location-outline" },
    { key: 'agree', title: 'Agree', icon: "document-text-outline" },
]
const routesClientTabs = [
    { key: 'locations', title: 'Locations', icon: "ios-location-outline" },
    { key: 'contact', title: 'Contact', icon: "ios-person-outline" },
    // { key: 'locations', title: 'Locations', icon: "ios-location-outline" },
    { key: 'info', title: 'Info', icon: 'ios-calendar-outline' },
    { key: 'agree', title: 'Agree', icon: "document-text-outline" },
]

const routesCompanyTabs = [
    { key: 'contact', title: 'Contact', icon: "ios-person-outline" },
    { key: 'address', title: 'Address', icon: "ios-location-outline" },
    { key: 'company', title: 'Company Information', icon: "document-text-outline" },
    { key: 'agree', title: 'Agree', icon: "document-text-outline" },
]
const routesWorkerTabs = [
    { key: 'contact', title: 'Contact', icon: "ios-person-outline" },
    { key: 'address', title: 'Address', icon: "ios-location-outline" },
    { key: 'worker', title: 'Worker Information', icon: "document-text-outline" },
    { key: 'agree', title: 'Agree', icon: "document-text-outline" },
]
const RegisterScreen: React.FC<IRegisterScreenProps> = (props) => {

    const [fields, setFields] = useImmer(copyObject(InitUserRegisterObj));
    const [indexTab, setIndexTab] = React.useState<number>(0);

    const history = useHistory()

    const [tabs, setTabs] = React.useState<Array<TabItem>>([])
    const [job, setJob] = React.useState<JobT>(null)
    const [accountType, setAccountType] = React.useState(null);
    const [currentAction, setCurrentAction] = React.useState(null);
    React.useEffect(() => {
        const varQueryParams = getQueryStringParams(history.location.search)
        const action = varQueryParams?.action
        setCurrentAction(action)
        setTabs(action == "registerClient" ? routesClientTabs : routesTabs)
        setJob(action == "registerClient" ? copyObject(JobObj) : null)
    }, []);

    React.useEffect(() => {
        if (fields.accountType == "company") {
            setTabs(routesCompanyTabs)
        } else if (fields?.accountType == "worker") {
            setTabs(routesWorkerTabs)
        }
    }, [fields?.accountType]);

    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }


    const updateJob = (key: string, value: any): void => {
        let tempJob: JobT = copyObject(job)
        tempJob[key] = value
        setJob(tempJob)
    }

    const onChangeField = (key: string, value: any): void => {

        // let cloneFields = copyObject(fields)
        // cloneFields[key] = value
        // console.log("cloneDirty", cloneFields)
        setFields((draft) => {
            draft[key] = value
        })
    }

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        if (isPreviousCurrentTab(newValue)) {
            setIndexTab(newValue);
        }
        // setIndexTab(newValue);
    };


    //
    const isPreviousCurrentTab = (index): boolean => {
        return index < indexTab ? true : false
    }

    const setAllfields = (data) => {
        setFields((dreft) => {
            Object.keys(data).map((key, index) => {
                if (_.has(dreft, key)) {
                    dreft[key] = data[key]
                }
            })
        })
    }



    /**
     * 
     */
    const renderScene = (tab: TabItem): JSX.Element => {
        switch (tab.key) {
            case "contact":
                return (
                    <ContactTab
                        onChangeField={onChangeField}

                        fields={fields}
                        nextTab={(newFields) => { setIndexTab(1) }}
                    />
                )
            case "address":
                return (
                    <AddressTab
                        onChangeField={onChangeField}

                        fields={fields}
                        nextTab={(newFields) => { setIndexTab(2) }}
                    />
                )
            case "locations":
                return (
                    <RegisterLocationsTab
                        onChangeField={onChangeField}
                        job={job}
                        updateJob={updateJob}
                        fields={fields}
                        nextTab={() => { setIndexTab(2) }}
                    />
                )
            case "info":
                return (
                    <RegisterJobInfoTab
                        onChangeField={onChangeField}
                        job={job}
                        updateJob={updateJob}
                        fields={fields}
                        nextTab={() => { setIndexTab(3) }}
                    />
                )
            case "company":
                return (
                    <CompanyTab
                        onChangeField={onChangeField}
                        fields={fields}
                        nextTab={() => { setIndexTab(3) }}
                    />
                )
            case "worker":
                return (
                    <WorkerTab
                        onChangeField={onChangeField}
                        fields={fields}
                        nextTab={() => { setIndexTab(3) }}
                    />
                )
            case "agree":
                return (
                    <AgreeTab
                        onChangeField={onChangeField}

                        fields={fields}
                        nextTab={(newFields) => {
                            setAllfields(InitUserRegisterObj)
                        }}
                    />
                )

            default:
                return null
        }
    }


    const renderSelectAccountType = () => {
        return (
            <Box style={{ gap: 10 }} className="d-flex mt-5 flex-column">
                <Typography variant='h6'>Account Type</Typography>
                <Typography >Please select account type</Typography>
                <Box style={{ gap: 10 }} className="d-flex flex-fill justify-content-start align-items-center">
                    <Button className='p-4' variant={accountType == "company" ? "contained" : "outlined"} onClick={(e) => setAccountType("company")} >
                        <ApartmentIcon />
                        <Typography>Company</Typography>
                    </Button>
                    <Button className='p-4' variant={accountType == "worker" ? "contained" : "outlined"} onClick={(e) => setAccountType("worker")}>
                        <EngineeringIcon />
                        <Typography>Worker</Typography>
                    </Button>
                </Box>
                <Button
                    disabled={!accountType}
                    className='mt-3'
                    fullWidth
                    color="success" variant="contained"
                    onClick={(e) => {
                        onChangeField("accountType", accountType)
                    }}>
                    <Typography variant="button" color="#fff">Next</Typography>
                </Button>
            </Box>
        )
    }

    return (
        <Box className="container" mb={5} pb={5}>
            <Box className="mt-5" style={{ display: "flex", minHeight: "100vh" }}>
                <Card
                    className="mb-5 w-100 h-100"
                    style={{
                        //   minHeight: "70vh",
                        justifyContent: "center", alignItems: "center"
                    }}>


                    <CardContent>
                        <Typography variant="h4" className='mb-2'>Register</Typography>
                        <Divider />
                        {!fields?.accountType && renderSelectAccountType()}
                        {fields?.accountType && <Box sx={{ borderBottom: 1, borderColor: 'divider', }} mt={2}>
                            <Tabs variant="fullWidth" value={indexTab} onChange={handleChangeTab} aria-label="basic tabs example">
                                {tabs.map((tab, index) => {
                                    return (
                                        <Tab key={index} label={`${tab.title}`} {...a11yProps(index)} />
                                    )
                                })}
                            </Tabs>
                        </Box>}

                        {fields?.accountType && tabs.map((item, index) => {
                            return (
                                <TabPanel key={index} value={indexTab} index={index}>
                                    {renderScene(item)}
                                </TabPanel>
                            )
                        })}
                    </CardContent>

                </Card>
            </Box>
        </Box>
    );
}

export default RegisterScreen
export { RegisterScreen }
